import { formatDateInTimezone } from '../unified-alarm-group/controls/utils';

interface DisarmWindow {
  startTimestamp: number;
  endTimestamp: number;
  timezone: string;
  days?: string[];
}

interface Props {
  disarmWindow?: DisarmWindow;
  title?: string;
}

export function MonitoringDisarmInfo(props: Props) {
  const { disarmWindow, title = 'Monitoring Disarmed' } = props;

  if (!disarmWindow || disarmWindow.endTimestamp * 1000 < Date.now()) {
    return null;
  }

  return (
    <div className="flex flex-col text-xs">
      <div className="space-x-2">
        <span className="text-sm font-bold text-red-500">{title}</span>
        <span>(time in {disarmWindow.timezone})</span>
      </div>
      <span>
        <b>From: </b>
        {formatDateInTimezone(
          disarmWindow.startTimestamp,
          disarmWindow.timezone
        )}
      </span>
      <span>
        <b>Till: </b>
        {formatDateInTimezone(disarmWindow.endTimestamp, disarmWindow.timezone)}
      </span>
    </div>
  );
}
